//src/app/features/questionnaires/edit/routes/index.tsx
import lodashGet from 'lodash.get';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import {
  selectPrepareQuestionnaire,
  TaxRequestType,
} from '../../create/PrepareQuestionnaire/slice';
import TaxQuestionnaire from '../TaxQuestionnaire';
import Automobiles from '../TaxQuestionnaire/AdditionalQuestions/Automobiles';
import BalanceSheet from '../TaxQuestionnaire/AdditionalQuestions/BalanceSheet';
import BookKeeping from '../TaxQuestionnaire/AdditionalQuestions/BookKeeping';
import Compensation from '../TaxQuestionnaire/AdditionalQuestions/Compensation';
import HomeOffice from '../TaxQuestionnaire/AdditionalQuestions/HomeOffice';
import MiscellaneousInformation from '../TaxQuestionnaire/AdditionalQuestions/MiscellaneousInformation';
import PaycheckProtectionProgramppp from '../TaxQuestionnaire/AdditionalQuestions/PaycheckProtectionProgramPPP';
import ProfitAndLossStatement from '../TaxQuestionnaire/AdditionalQuestions/ProfitandLossStatement';
import RentalActivity from '../TaxQuestionnaire/AdditionalQuestions/RentalActivity';
import SpecialDeductionsInformation from '../TaxQuestionnaire/AdditionalQuestions/SpecialDeductionsInformation';
import BusinessType from '../TaxQuestionnaire/BusinessInfo/BusinessType';
import GeneralInfo from '../TaxQuestionnaire/BusinessInfo/GeneralInfo';
import IndustryAndPrimaryActivity from '../TaxQuestionnaire/BusinessInfo/Industryandprimaryactivity';
import Owners from '../TaxQuestionnaire/BusinessInfo/Owners';
import NonUsCorpOfPartnership from '../TaxQuestionnaire/Income/CorporationTrust/NonUSCorpofPartnership';
import NonUsTrust from '../TaxQuestionnaire/Income/CorporationTrust/NonUSTrust';
import UsCorpOrPartnership from '../TaxQuestionnaire/Income/CorporationTrust/USCorpOrPartnership';
import UsTrust from '../TaxQuestionnaire/Income/CorporationTrust/USTrust';
import HomeSale from '../TaxQuestionnaire/Income/HomeSale';
import Investments from '../TaxQuestionnaire/Income/Investments';
import OtherIncome from '../TaxQuestionnaire/Income/OtherIncome';
import Dividends from '../TaxQuestionnaire/Income/PassiveIncome/Dividends';
import Interest from '../TaxQuestionnaire/Income/PassiveIncome/Interest';
import Pension from '../TaxQuestionnaire/Income/PassiveIncome/Pension';
import RentalIncome from '../TaxQuestionnaire/Income/PassiveIncome/RentalIncome';
import SelfEmployment from '../TaxQuestionnaire/Income/SelfEmployment';
import IncomeFromTheUs from '../TaxQuestionnaire/Income/Wages/IncomeFromTheUS';
import IncomeOutsideOfTheUs from '../TaxQuestionnaire/Income/Wages/IncomeOutsideOfTheUS';
import AccountsList from '../TaxQuestionnaire/NonUSFinancialAccounts/AccountsList';
import NonUsFinancialAccounts from '../TaxQuestionnaire/NonUSFinancialAccounts/NonUSFinancialAccounts';
import Notes from '../TaxQuestionnaire/Notes';
import Citizenship from '../TaxQuestionnaire/PersonalDetails/TheBasics/Citizenship';
// import CovidRelief from '../TaxQuestionnaire/PersonalDetails/TheBasics/CovidRelief';
import Dependents from '../TaxQuestionnaire/PersonalDetails/TheBasics/Dependents';
import Family from '../TaxQuestionnaire/PersonalDetails/TheBasics/Family';
import Logistics from '../TaxQuestionnaire/PersonalDetails/TheBasics/Logistics';
import Name from '../TaxQuestionnaire/PersonalDetails/TheBasics/Name';
import PastFillings from '../TaxQuestionnaire/PersonalDetails/TheBasics/PastFillings';
import CurrentAddress from '../TaxQuestionnaire/PersonalDetails/WhereILive/CurrentAddress';
import History from '../TaxQuestionnaire/PersonalDetails/WhereILive/History';
import HousingArrangements from '../TaxQuestionnaire/PersonalDetails/WhereILive/HousingArrangements';
import SaleOfOtherAssets from '../TaxQuestionnaire/SoleProprietorship/SaleofOtherAssets';
import SoleProprietorshipform1099MiscAnd1099Nec from '../TaxQuestionnaire/SoleProprietorship/SoleProprietorshipForm1099MISCand1099NEC';
import SpouseDivedends from '../TaxQuestionnaire/SpouseIncome/Dividends';
import SpouseInterest from '../TaxQuestionnaire/SpouseIncome/Interest';
import SpousePension from '../TaxQuestionnaire/SpouseIncome/Pension';
import SpouseWages from '../TaxQuestionnaire/SpouseIncome/Wages';
import Summary from '../TaxQuestionnaire/Summary';
import DocumentsChecklist from '../TaxQuestionnaire/Summary/DocumentsChecklist';
import Deductions from '../TaxQuestionnaire/TaxesDeductions/Deductions';
import RetirementSocSecurity from '../TaxQuestionnaire/TaxesDeductions/RetirementSocSecurity';
import TaxesPaid from '../TaxQuestionnaire/TaxesDeductions/TaxesPaid';
import TaxesPaidSpouse from '../TaxQuestionnaire/TaxesDeductions/TaxesPaidSpouse';
import { QuestionnaireRoutes, selectQuestionnaireRoutes } from './slice';

export default function EditQuestionnaireRoutes() {
  const storeQuestionnaireRoutes = useSelector(selectQuestionnaireRoutes);
  const { taxRequestType } = useSelector(selectPrepareQuestionnaire);

  return (
    <>
      {taxRequestType && (
        <Routes>
          <Route path="*" element={<TaxQuestionnaire />}>
            <Route
              path=""
              element={
                <Navigate
                  to={`${
                    taxRequestType === TaxRequestType.Business
                      ? 'businessInfo'
                      : 'personal_details'
                  }`}
                  replace={true}
                />
              }
            />
            {redirectToDefaultQuestionnaireRoute(storeQuestionnaireRoutes)}
            {renderQuestionnaireRoutes(storeQuestionnaireRoutes)}
          </Route>
        </Routes>
      )}
    </>
  );
}

const ELEMENTS = {
  personal_details: {
    the_basics: {
      name: <Name />,
      citizenship: <Citizenship />,
      past_fillings: <PastFillings />,
      family: <Family />,
      dependents: <Dependents />,
      // covid_relief: <CovidRelief />,
      logistics: <Logistics />,
    },
    where_i_live: {
      current_address: <CurrentAddress />,
      history: <History />,
      housing_arrangements: <HousingArrangements />,
    },
  },
  income: {
    wages: {
      incomeFromTheUs: <IncomeFromTheUs />,
      incomeOutsideOfTheUs: <IncomeOutsideOfTheUs />,
    },
    corporationTrust: {
      usCorpOrPartnership: <UsCorpOrPartnership />,
      nonUsCorpOfPartnership: <NonUsCorpOfPartnership />,
      usTrust: <UsTrust />,
      nonUsTrust: <NonUsTrust />,
    },
    homeSale: <HomeSale />,
    investments: <Investments />,
    otherIncome: <OtherIncome />,
    passiveIncome: {
      dividends: <Dividends />,
      interest: <Interest />,
      pension: <Pension />,
      rentalIncome: <RentalIncome />,
    },
    selfEmployment: <SelfEmployment />,
  },
  spouseIncome: {
    dividends: <SpouseDivedends />,
    interest: <SpouseInterest />,
    pension: <SpousePension />,
    wages: <SpouseWages />,
  },
  taxesDeductions: {
    deductions: <Deductions />,
    retirementSocSecurity: <RetirementSocSecurity />,
    taxesPaid: <TaxesPaid />,
    taxesPaidSpouse: <TaxesPaidSpouse />,
  },
  nonUsFinancialAccounts: {
    nonUsFinancialAccounts: <NonUsFinancialAccounts />,
    accountsList: <AccountsList />,
  },
  notes: { notes: <Notes /> },
  summary: { summary: <Summary />, documentsChecklist: <DocumentsChecklist /> },
  businessInfo: {
    businessType: <BusinessType />,
    industryandprimaryactivity: <IndustryAndPrimaryActivity />,
    generalInfo: <GeneralInfo />,
    owners: <Owners />,
  },

  additionalQuestions: {
    automobiles: <Automobiles />,
    homeOffice: <HomeOffice />,
    bookKeeping: <BookKeeping />,
    compensation: <Compensation />,
    balanceSheet: <BalanceSheet />,
    profitandLossStatement: <ProfitAndLossStatement />,
    rentalActivity: <RentalActivity />,
    specialDeductionsInformation: <SpecialDeductionsInformation />,
    paycheckProtectionProgramPPP: <PaycheckProtectionProgramppp />,
    miscellaneousInformation: <MiscellaneousInformation />,
  },

  soleProprietorship: {
    soleProprietorshipForm1099MISCand1099NEC: (
      <SoleProprietorshipform1099MiscAnd1099Nec />
    ),
    saleofOtherAssets: <SaleOfOtherAssets />,
  },
};

const renderQuestionnaireRoutes = (
  storeQuestionnaireRoutes: QuestionnaireRoutes,
) => {
  return Object.values(storeQuestionnaireRoutes.routes).map((route) => {
    const { path, title, isValid, toggle, ...subRoutes } = route;
    if (Object.values(subRoutes).length > 0) {
      return Object.values(subRoutes).map((subRoute) => {
        const {
          path: subRoutePath,
          title: subRouteTitle,
          isValid: subRouteIsValid,
          toggle: subRouteIsToggle,
          ...subTabs
        } = subRoute;
        if (Object.values(subTabs).length > 0) {
          const defaultSubTab = Object.values(subTabs)[0] as any;

          return Object.values(subTabs)
            .map((subTab: any) => (
              <Route
                path={`${path}/${subRoutePath}/${subTab.path}`}
                element={lodashGet(
                  ELEMENTS,
                  `${path}.${subRoutePath}.${subTab.path}`,
                )}
              />
            ))
            .concat(
              <Route
                path={`${path}/${subRoutePath}`}
                element={<Navigate to={defaultSubTab?.path} replace={true} />}
              />,
            );
        } else {
          return (
            <Route
              path={`${path}/${subRoutePath}`}
              element={lodashGet(ELEMENTS, `${path}.${subRoutePath}`)}
            />
          );
        }
      });
    } else {
      return <Route path={`${path}`} element={lodashGet(ELEMENTS, path)} />;
    }
  });
};

const redirectToDefaultQuestionnaireRoute = (
  storeQuestionnaireRoutes: QuestionnaireRoutes,
) => {
  return Object.values(storeQuestionnaireRoutes.routes).map((route) => {
    const { path, title, isValid, toggle, ...subRoutes } = route;
    const defaultSubRoute = Object.values(subRoutes)[0];

    if (defaultSubRoute) {
      const {
        path: subRoutePath,
        title: subRouteTitle,
        isValid: subRouteIsValid,
        toggle: subRouteIsToggle,
        ...subTabs
      } = defaultSubRoute;
      const defaultSubTab: any = Object.values(subTabs)[0];

      return (
        <React.Fragment key={path}>
          {subRoutes && (
            <Route
              path={route.path}
              element={
                <Navigate
                  to={
                    defaultSubTab
                      ? `${subRoutePath}/${defaultSubTab?.path}`
                      : `${subRoutePath}`
                  }
                  replace={true}
                />
              }
            />
          )}
        </React.Fragment>
      );
    }
    return null;
  });
};
